import {lazy} from 'react';

const Amy3D = lazy(() => import(/* webpackChunkName: "amy3DLazy" */ './amy3DLazy'));

export default Amy3D;
